import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS } from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import VinWonderPriceList from './VinWonderPriceList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class VinWonderPrices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageIndex: this.props.vinWonderPricetate.pageIndex,
                pageSize: this.props.vinWonderPricetate.pageSize,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER_PRICE);
        this.initVinWonderPrices();
    }

    render() {
        const { t, match } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, vinWonderPrices } = this.props.vinWonderPricetate;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex };
        const { filters } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vinWonderPrices'}
                        titleHeader={t('navigation.vinWonderPrice')}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.CREATE.path, { vin_wonder_id: match.params.vin_wonder_id })}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <VinWonderPriceList loading={isFetching}
                        vinWonderId={match.params.vin_wonder_id}
                        permisions={permisionActions}
                        vinWonderPrices={vinWonderPrices}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeletePrice={this.onDeletePrice}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    initVinWonderPrices() {
        const { match } = this.props;
        const filters = { ...this.state.filters, vinWonderId: match.params.vin_wonder_id };
        this.setState({ filters });
        this.props.getListVinWonderPrices(filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPrices(newFilters);
    };

    onDeletePrice = (priceItem) => {
        this.props.deleteVinWonderPriceDetail(priceItem, {
            filters: {
                pageSize: this.props.vinWonderPricetate.pageSize,
                pageIndex: this.props.vinWonderPricetate.pageIndex
            }
        })
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.vin_wonder_id) {
            const path = Func.getPathWithParams(PATHS.VIN_WONDER.DETAIL.path, { id: match.params.vin_wonder_id })
            this.props.history.push(path);
        }
    }


}
